import * as z from "zod/v4";

export const getCustomersCount = {
  name: "getCustomersCount" as const,
  input: z.object({ search: z.string().optional() }),
  output: z.object({ totalCount: z.number() }),
};
